import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BetService } from '@modules/games/bet.service';
import { GameModel } from '@modules/games/game.model';
import { bottomSheetTipoApuestasComponent } from '@shared/components/bottomSheet/bottomSheetTipoApuestas/bottomSheetTipoApuestas.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { EDevice } from '@enums/common/sizes.enum';
import { take } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'board',
    templateUrl: './board.component.html',
    styleUrls: ['./board.component.scss'],
    standalone: false
})
export class BoardComponent implements OnInit, OnDestroy {

	@Input() gameId: number;
	@Input() isWeekly: boolean = false;
	@Input() device: EDevice;
	showBetsList = true;

	devices = EDevice;

	betType: any = undefined;

	public freeBet = false; // Jugada gratis

	constructor(
		public gameModel: GameModel,
		public betService: BetService,
		private bottomSheet: MatBottomSheet,
		private breakpointObserver: BreakpointObserver,
		private toastrService: ToastrService
	) {
	}

	ngOnInit(): void {

		this.gameModel.isWeekly = this.isWeekly;
		this.gameModel.setupBoard(this.gameId, undefined);
		this.betService.freeBetObservable$.subscribe((res: any) => {
			this.freeBet = res;
			// console.log('freeBet', this.freeBet);

			if(this.freeBet) {
				this.gameModel.maxBetsLimit = this.gameId === 1 ? (this.isWeekly ? 1 : 2) : 1;
			}
		});	
	}

	toggleBetsList(): void {
		this.showBetsList = !this.showBetsList;
	}

	selectBetType() {
		const isMobile = this.breakpointObserver.isMatched(Breakpoints.Handset);

		this.bottomSheet.open(bottomSheetTipoApuestasComponent, {
			data: {
				combinaciones: this.gameModel.getMultiplesList(this.gameId),
			},
			panelClass: isMobile ? 'bottom-sheet-full-screen' : 'bottom-sheet-center'
		}).afterDismissed().subscribe((betType) => {
			if (!betType) return;
			this.betType = betType;
			this.gameModel.betType = betType
			this.gameModel.changeBetType(betType, this.gameId);
		});
	}

	private isChangingBet = false;

	changeBetNumberWithDelay(amount: number): void {
		if ((this.gameModel.bets.length + amount) > this.gameModel.maxBetsLimit) {
			this.toastrService.error('Límite de apuestas alcanzado!');
		}
		if (!this.isChangingBet) {
			this.isChangingBet = true;
			this.gameModel.changeBetNumber(amount);
			if (amount >= 1 && ((this.gameModel.selectedBet + amount) < this.gameModel.maxBetsLimit)) {
				this.gameModel.selectedBet = (this.gameModel.selectedBet + amount);
			}

			setTimeout(() => {
				this.isChangingBet = false;
			}, 100);
		}
	}

	ngOnDestroy(): void {
		this.gameModel.selectedBet = 0;
	}
}